<template>
	<div class="w-full flex flex-col items-center gap-4 px-4">
		<Section
			title="DADOS DO PACIENTE"
			:opened="true"
		>
			<div class="w-full flex flex-col items-center">
				<div class="w-full flex items-center">
					<FormGroup
						v-model="form.cpf"
						class="w-4/12"
						input-type="checkbox"
						checkbox-label="CPF"
						:omit-info="true"
						entity-key="cpf"
					/>
					<FormGroup
						v-model="form.rg"
						class="w-4/12"
						input-type="checkbox"
						checkbox-label="RG/UF"
						:omit-info="true"
						entity-key="rg"
					/>
					<FormGroup
						v-model="form.cns"
						class="w-4/12"
						input-type="checkbox"
						checkbox-label="CNS"
						:omit-info="true"
						entity-key="cns"
					/>
				</div>
				<div class="w-full flex items-center">
					<FormGroup
						v-model="form.birth_date"
						class="w-4/12"
						input-type="checkbox"
						checkbox-label="DATA DE NASCIMENTO"
						:omit-info="true"
						entity-key="birth_date"
					/>
					<FormGroup
						v-model="form.sex"
						class="w-4/12"
						input-type="checkbox"
						checkbox-label="SEXO"
						:omit-info="true"
						entity-key="sex"
					/>
					<FormGroup
						v-model="form.email"
						class="w-4/12"
						input-type="checkbox"
						checkbox-label="E-MAIL"
						:omit-info="true"
						entity-key="email"
					/>
				</div>
				<div class="w-full flex items-center">
					<FormGroup
						v-model="form.mother_name"
						class="w-4/12"
						input-type="checkbox"
						checkbox-label="NOME DA MÃE"
						:omit-info="true"
						entity-key="mother_name"
					/>
				</div>
			</div>
		</Section>

		<Section
			title="ENDEREÇO"
			:opened="true"
		>
			<div class="w-full flex flex-col items-center">
				<div class="w-full flex items-center">
					<FormGroup
						v-model="form.cep"
						class="w-4/12"
						input-type="checkbox"
						checkbox-label="CEP"
						:omit-info="true"
						entity-key="cep"
					/>
					<FormGroup
						v-model="form.street"
						class="w-4/12"
						input-type="checkbox"
						checkbox-label="LOGRADOURO"
						:omit-info="true"
						entity-key="street"
					/>
					<FormGroup
						v-model="form.neighborhood"
						class="w-4/12"
						input-type="checkbox"
						checkbox-label="BAIRRO"
						:omit-info="true"
						entity-key="neighborhood"
					/>
				</div>
				<div class="w-full flex items-center">
					<FormGroup
						v-model="form.city"
						class="w-4/12"
						input-type="checkbox"
						checkbox-label="MUNICÍPIO"
						:omit-info="true"
						entity-key="city"
					/>
					<FormGroup
						v-model="form.state"
						class="w-4/12"
						input-type="checkbox"
						checkbox-label="UF"
						:omit-info="true"
						entity-key="state"
					/>
					<FormGroup
						v-model="form.complement"
						class="w-4/12"
						input-type="checkbox"
						checkbox-label="COMPLEMENTO"
						:omit-info="true"
						entity-key="complement"
					/>
				</div>
			</div>
		</Section>

		<Section
			title="DADOS COMPLEMENTARES"
			:opened="true"
		>
			<div class="w-full flex flex-col items-center">
				<div class="w-full flex items-center">
					<FormGroup
						v-model="form.phone_2"
						class="w-4/12"
						input-type="checkbox"
						checkbox-label="TELEFONE 2"
						:omit-info="true"
						entity-key="phone_2"
					/>
					<FormGroup
						v-model="form.phone_3"
						class="w-4/12"
						input-type="checkbox"
						checkbox-label="TELEFONE 3"
						:omit-info="true"
						entity-key="phone_3"
					/>
					<FormGroup
						v-model="form.scholarship"
						class="w-4/12"
						input-type="checkbox"
						checkbox-label="ESCOLARIDADE"
						:omit-info="true"
						entity-key="scholarship"
					/>
				</div>
				<div class="w-full flex items-center">
					<FormGroup
						v-model="form.race"
						class="w-4/12"
						input-type="checkbox"
						checkbox-label="RAÇA"
						:omit-info="true"
						entity-key="race"
					/>
					<FormGroup
						v-model="form.religion"
						class="w-4/12"
						input-type="checkbox"
						checkbox-label="RELIGIÃO"
						:omit-info="true"
						entity-key="religion"
					/>
				</div>
			</div>
		</Section>
	</div>
</template>

<script>
	import { mapActions } from 'vuex'
	import { useConfirmation, useError } from '@/composables'

	export default {
		name: 'RegisterObligations',
		props: {
			organization: {
				type: Object,
				required: true,
			},
		},
		data() {
			return {
				form: {
					config_id: null,

					cpf: false,
					rg: false,
					cns: false,
					birth_date: false,
					sex: false,
					email: false,
					mother_name: false,

					cep: false,
					street: false,
					neighborhood: false,
					city: false,
					state: false,
					complement: false,

					phone_2: false,
					phone_3: false,
					scholarship: false,
					race: false,
					religion: false,
				},
			}
		},
		watch: {
			organization: {
				handler(newVal) {
					if (newVal?.instances[0]?.config?.register_obligations) {
						this.form = {
							config_id: newVal?.instances[0]?.config?.id,
							...newVal?.instances[0]?.config
								?.register_obligations,
						}
					}
				},
				immediate: true,
				deep: true,
			},
		},
		methods: {
			async SaveRegisterObligations() {
				return window.api
					.call('post', '/save-register-obligations', {
						config_id: this.config_id,
						...this.form,
					})
					.then(({ status }) => {
						if (status !== 200) {
							useError(
								'NÃO FOI POSSÍVEL SALVAR A OBRIGATORIEDADE DE CADASTRO. TENTE NOVAMENTE MAIS TARDE.'
							)
							return
						}

						useConfirmation()
						this.$emit('refresh')
					})
			},
		},
	}
</script>

<style lang="scss" scoped></style>
